import { render, staticRenderFns } from "./NotableInvidualsInfoModal.vue?vue&type=template&id=5eea694b"
import script from "./NotableInvidualsInfoModal.vue?vue&type=script&lang=js"
export * from "./NotableInvidualsInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports